import React from 'react';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import useApp from '../store/app/appContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function RouterRedirect() {

  const { appState: { isAuthenticated } } = useApp();

  let query = useQuery();
  const scanandgo = query.get('scanandgo');
  const becomeAPartner = query.get('becomeAPartner');

  if (scanandgo) return <Redirect to={!isAuthenticated ? '/patient' : '/scanandgo'}/>
  if (becomeAPartner) return <Redirect to={!isAuthenticated ? '/patient' : '/professional/become-a-partner'}/>

  return  <Redirect to={!isAuthenticated ? '/patient' : '/dashboard'}/>
}

export default RouterRedirect;

